import { render, staticRenderFns } from "./d-tracking-link.vue?vue&type=template&id=70c0c9a9&"
import script from "./d-tracking-link.vue?vue&type=script&lang=js&"
export * from "./d-tracking-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports